<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_ii"></a><a id="Copyright">For students past and present at Winkfield Place<br/>
and the Cordon Bleu Cookery School</a></p><a id="Copyright">
</a><p class="copyright3"><a id="Copyright">This new edition published in 2011 by<br/>
Grub Street<br/>
4 Rainham Close<br/>
London<br/>
SW11 6SS<br/>
Email: </a><a href="mailto:food@grubstreet.co.uk">food@grubstreet.co.uk</a><br/>
<a href="http://www.grubstreet.co.uk" target="_blank">www.grubstreet.co.uk</a></p>
<p class="copyright3">Copyright this edition © Grub Street 2011</p>
<p class="copyright3">First published by J.M. Dent &amp; Sons Ltd, 1956<br/>
Reprinted 1957, 1958, 1960, 1961, 1964, 1967<br/>
Reprinted with corrections and minor revisions 1971<br/>
Reissued 1978, Reprinted 1983, Reissued 1990<br/>
Reissued by Grub Street 2004</p>
<p class="copyright3">Designed and formatted by Sarah Driver<br/>
Line Drawings by Fred van Deelen</p>
<p class="copyright3">British Library Cataloguing in Publication Data<br/>
Spry, Constance<br/>
    The Constance Spry cookery book<br/>
1.  Cookery<br/>
I.  Title II. Hume, Rosemary<br/>
641.5</p>
<p class="copyright3">ISBN 978-1-908117-17-5<br/>
EPUB ISBN: 9781610047142</p>
<p class="copyright3">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means,<br/>
electronic or mechanical, including photocopying, recording or any information storage and retrieval<br/>
system, without permission in writing from the publisher.</p>
<p class="copyright3"><b>Publisher’s note to this edition</b><br/>
All that we have done to this classic cookbook is to add metric measurements to all the recipes to assist<br/>
the present day cook. The integrity of the original 1956 text remains untouched and unaltered. Hence<br/>
you will still find references to pre-decimal coinage, shops that are now long disappeared and terminology<br/>
which may to the modern reader sound quaint and outmoded. We had no wish, nor did we<br/>
feel it necessary, to update the language of a wonderful period piece which offers a valuable insight<br/>
into a bygone age.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?929981ce